import { render, staticRenderFns } from "./ScoreScale.vue?vue&type=template&id=07a7f9dc&scoped=true&"
import script from "./ScoreScale.vue?vue&type=script&lang=js&"
export * from "./ScoreScale.vue?vue&type=script&lang=js&"
import style0 from "./ScoreScale.vue?vue&type=style&index=0&id=07a7f9dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a7f9dc",
  null
  
)

export default component.exports